var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerticalWindDirectionArrow = function SvgVerticalWindDirectionArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.175 4.82.004 16.494a.56.56 0 0 1-.158.4.54.54 0 0 1-.408.165.55.55 0 0 1-.408-.158.55.55 0 0 1-.157-.407L12.043 4.82 7.149 9.716a.556.556 0 0 1-.806-.004.555.555 0 0 1 .003-.799L12.1 3.162a.7.7 0 0 1 .51-.217q.293 0 .51.217l5.756 5.756q.17.171.169.402a.56.56 0 0 1-.173.403.54.54 0 0 1-.4.17.56.56 0 0 1-.398-.173z"
  })));
};
export default SvgVerticalWindDirectionArrow;